import types from './types';

const { LOADING, LOADED, LOADER_DISPLAY, RESET_LOADING } = types;

const initialState = {
  pendingCount: 0,
  loaderVisible: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOADING:
      return {
        ...state,
        pendingCount: state.pendingCount + 1,
      };
    case LOADER_DISPLAY:
      return {
        ...state,
        loaderVisible: state.pendingCount > 0,
      };
    case LOADED:
      return {
        ...state,
        pendingCount: Math.max(0, state.pendingCount - 1),
        loaderVisible: state.pendingCount <= 1 ? false : state.loaderVisible,
      };
    case RESET_LOADING:
      return {
        ...state,
        pendingCount: 0,
        loaderVisible: false,
      };
    default:
      return state;
  }
}
